import { render, staticRenderFns } from "./AttendancesList.vue?vue&type=template&id=375490e3&scoped=true&"
import script from "./AttendancesList.vue?vue&type=script&lang=js&"
export * from "./AttendancesList.vue?vue&type=script&lang=js&"
import style0 from "./AttendancesList.vue?vue&type=style&index=0&id=375490e3&prod&lang=scss&"
import style1 from "./AttendancesList.vue?vue&type=style&index=1&id=375490e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375490e3",
  null
  
)

export default component.exports